var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "access-view" },
    [
      _c(
        "header",
        { staticClass: "access-view__header" },
        [
          _c("h1", { staticClass: "access-view__title" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("AccessView.label.header.title")) +
                "\n    "
            ),
          ]),
          _c(
            "DsButton",
            {
              staticClass: "access-view__button",
              on: { click: _vm.openAccessModal },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("AccessView.label.header.button")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _c("p", { staticClass: "access-view__subtitle" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("AccessView.label.subtitle")) + "\n  "),
      ]),
      _c(
        "div",
        { staticClass: "access-view__search" },
        [
          _c("v-text-field", {
            attrs: {
              dense: "",
              light: "",
              outlined: "",
              "prepend-inner-icon": "mdi-magnify",
              color: "var(--ds-color-icon-2)",
              placeholder: _vm.$t("AccessView.label.input.placeholder"),
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _vm.success
        ? _c("v-data-table", {
            attrs: {
              light: "",
              headers: _vm.headers,
              items: _vm.accesses,
              "items-per-page": 10,
              search: _vm.search,
              "loading-text": _vm.$t("AccessView.notification.loadingData"),
              loading: _vm.loading,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.createdDate`,
                  fn: function ({ item }) {
                    return [
                      _c("span", [_vm._v(_vm._s(_vm.getFormattedDate(item)))]),
                    ]
                  },
                },
                {
                  key: `item.isStaging`,
                  fn: function ({ item }) {
                    return [_c("span", [_vm._v(_vm._s(_vm.getLabel(item)))])]
                  },
                },
                {
                  key: `item.users`,
                  fn: function ({ item }) {
                    return [_c("span", [_vm._v(_vm._s(item.firstAccess))])]
                  },
                },
                {
                  key: `item.actions`,
                  fn: function ({ item }) {
                    return [
                      _c("DsButton", {
                        attrs: { icon: "", name: "edit", color: "ghost" },
                        on: {
                          click: function ($event) {
                            return _vm.setAccessToEdit(item)
                          },
                        },
                      }),
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            top: "",
                            color: "var(--ds-color-reverse)",
                            disabled: !_vm.disableRemoveButton(item),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g(
                                        _vm._b(
                                          { staticClass: "d-inline-block" },
                                          "div",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              light: "",
                                              color: "grey darken-1",
                                              disabled:
                                                _vm.disableRemoveButton(item),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeAccess(item)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { light: "" } },
                                              [
                                                _vm._v(
                                                  "\n                mdi-trash-can-outline\n              "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [_c("span", [_vm._v("Exclusão desabilitada")])]
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm.formDashModal
        ? _c("AccessModal", {
            attrs: {
              dashboard: _vm.accessToEdit,
              "modal-title": _vm.$t("AccessView.label.modal.title"),
            },
            model: {
              value: _vm.formDashModal,
              callback: function ($$v) {
                _vm.formDashModal = $$v
              },
              expression: "formDashModal",
            },
          })
        : _vm._e(),
      _c("DsModal", {
        attrs: {
          open: _vm.accessDialog,
          title: _vm.$t("AccessView.dialog.title"),
          text: _vm.$t("AccessView.dialog.text"),
          "primary-button-label": _vm.$t(
            "AccessView.dialog.primaryButtonLabel"
          ),
          "secondary-button-label": _vm.$t(
            "AccessView.dialog.secondaryButtonLabel"
          ),
          width: "600px",
        },
        on: {
          secondary: function ($event) {
            return _vm.cancelAction()
          },
          primary: function ($event) {
            return _vm.confirmAction()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }